import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

interface ClearFlagConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
}

const ClearFlagConfirmationModal: React.FC<ClearFlagConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading = false,
}) => {
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (keyCode === 27) onClose(); // ESC key
        };
        if (isOpen) {
            document.addEventListener('keydown', keyHandler);
        }
        return () => document.removeEventListener('keydown', keyHandler);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className='fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5'
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
            >
                <button
                    className='absolute right-4 top-4 text-gray-600 hover:text-gray-900'
                    onClick={onClose}
                    disabled={isLoading}
                >
                    <RxCross2 />
                </button>
                <div className='p-8'>
                    <div className='mb-4'>
                        <h2 className='mb-[30px] text-[22px] font-bold'>
                            Clear Flag from Expense Item?
                        </h2>
                    </div>

                    <p className='mb-[30px]'>
                        Are you sure you want to clear the flag from this expense item? This will remove the flagged comment and reset the flag status, but the expense item will remain in the fund request.
                    </p>

                    <div className='flex justify-start space-x-4'>
                        <button
                            onClick={onClose}
                            disabled={isLoading}
                            className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            No, Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isLoading}
                            className='rounded-full bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-black transition-colors duration-500 hover:bg-yellow disabled:opacity-50 disabled:cursor-not-allowed'
                        >
                            {isLoading ? 'Clearing...' : 'Yes, Clear Flag'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClearFlagConfirmationModal;
